// src/components/ResultsBanner.tsx
import React from 'react';
import { AlertTriangle, Shield } from 'lucide-react';
import './ResultsBanner.css';

interface ResultsBannerProps {
  verdict: {
    family: string;
    threat_level: string;
    confidence: number;
  };
}

const ResultsBanner: React.FC<ResultsBannerProps> = ({ verdict }) => {
  const getColor = () => {
    switch (verdict.threat_level) {
      case 'CRITICAL': return 'critical';
      case 'HIGH': return 'high';
      case 'MEDIUM': return 'medium';
      default: return 'clean';
    }
  };

  const getIcon = () => {
    switch (verdict.threat_level) {
      case 'CRITICAL': return <AlertTriangle size={32} />;
      case 'HIGH': return <AlertTriangle size={32} />;
      case 'MEDIUM': return <Shield size={32} />;
      default: return <Shield size={32} />;
    }
  };

  return (
    <div className={`results-banner ${getColor()}`}>
      <div className="banner-content">
        <div className="banner-left">
          {getIcon()}
          <div>
            <h2 className="family-name">{verdict.family}</h2>
            <span className="threat-badge">{verdict.threat_level}</span>
          </div>
        </div>
        <div className="banner-right">
          <div className="confidence-stats">
            <span className="confidence-label">Confidence</span>
            <span className="confidence-value">{(verdict.confidence * 100).toFixed(2)}%</span>
          </div>
          <div className="confidence-bar">
            <div 
              className="confidence-fill" 
              style={{ width: `${verdict.confidence * 100}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultsBanner;
